import { createFileRoute } from '@tanstack/react-router';

import { NIS2Dashboard } from '@/features/nis2/components/NIS2Dashboard';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/nis2/dashboard')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.nis2Dashboard'),
  }),
  component: NIS2DashboardRoute,
});

function NIS2DashboardRoute() {
  return <NIS2Dashboard />;
}
